import React, { Fragment, useState } from 'react';
import { withRouter } from 'react-router-dom';
import useForm from 'react-hook-form';
import { toast } from 'react-toastify';
import api from '../../config/axios';

import Breadcrumb from '../common/breadcrumb';
import { useStateValue } from '../../store';

const messageVariants = {
    formal: (name, repartidor) =>
        `Hola Sr(a). ${name}, un gusto. Mi nombre es ${repartidor} de Aguaman. Tal como le indiqué, con nuestro servicio express recibe su botellón de agua en 30 minutos. Le llevamos un botellón lleno y nos da su envase vacío. Precio del servicio: $3.60 USD. Para pedidos presione el siguiente enlace: https://aguamandelivery.com/pedir-botellon`,
    cercano: (name, repartidor) =>
        `¡Hola ${name}! Soy ${repartidor} de Aguaman — el del agua. Nos conocimos hoy y le comenté que le podemos llevar el botellón en 30 minutos cuando lo necesite. Guarde mi número, que en cualquier momento le quedará sin agua. Para pedir rápido: https://aguamandelivery.com/pedir-botellon`,
    directo: (name, repartidor) =>
        `Hola ${name}, soy ${repartidor} de Aguaman. Le dejo mi número para cuando necesite su botellón de agua. Se lo llevamos en 30 minutos, le traemos uno lleno y nos da el vacío. $3.60 USD. Pida por aquí: https://aguamandelivery.com/pedir-botellon`,
};

const ClientInvitation = withRouter(() => {
    const [{ auth }] = useStateValue();
    const {
        handleSubmit: handleSubmitPush,
        register: registerPush,
        errors: errorsPush,
    } = useForm();
    const [selectedVariant, setSelectedVariant] = useState('formal');

    const sendInvitation = async (data) => {
        const phoneParsed = data.phone.replace('0', '58');
        const nameParsed = auth.user.name.split(' ')[0];
        const messageText = messageVariants[selectedVariant](
            data.name,
            nameParsed,
        );
        const waUrl = `https://wa.me/${phoneParsed}?text=${encodeURIComponent(messageText)}`;

        // Persistir el lead antes de abrir WhatsApp (U3)
        try {
            await api.post('/lead', {
                name: data.name,
                phone: data.phone,
                observation: data.observation || null,
            });
        } catch (err) {
            toast.error('No se pudo guardar el lead, pero se abrirá WhatsApp igual');
        }

        window.open(waUrl);
        return;
    };

    return (
        <Fragment>
            <Breadcrumb title="Invitar cliente" />
            <div className="container-fluid">
                <div className="row">
                    <div className="col-sm-12">
                        <div className="card">
                            <div className="card-body">
                                <form
                                    onSubmit={handleSubmitPush(sendInvitation)}
                                    className="needs-validation user-add"
                                    noValidate=""
                                >
                                    <div className="form-group row">
                                        <label className="col-xl-3 col-md-4">
                                            <span>*</span> Primer Nombre
                                        </label>
                                        <input
                                            className="form-control col-xl-4 col-md-7"
                                            type="text"
                                            name="name"
                                            ref={registerPush({
                                                required: true,
                                            })}
                                        />
                                        <p className="message-error-input">
                                            {errorsPush.name &&
                                                errorsPush.name.type === 'required' &&
                                                'Nombre obligatorio'}
                                        </p>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-xl-3 col-md-4">
                                            <span>*</span> Teléfono
                                        </label>
                                        <input
                                            className="form-control col-xl-5 col-md-7"
                                            type="tel"
                                            name="phone"
                                            ref={registerPush({
                                                required: true,
                                            })}
                                        />
                                        <p className="message-error-input">
                                            {errorsPush.phone &&
                                                errorsPush.phone.type === 'required' &&
                                                'Teléfono obligatorio'}
                                        </p>
                                    </div>
                                    <div className="form-group row mb-3">
                                        <label className="col-xl-3 col-md-4">
                                            Observación (ej: Cliente de la arboleda)
                                        </label>
                                        <input
                                            className="form-control col-xl-5 col-md-7"
                                            type="text"
                                            name="observation"
                                            ref={registerPush({})}
                                        />
                                    </div>
                                    <div className="form-group row mb-3">
                                        <label className="col-xl-3 col-md-4">
                                            Variante de mensaje
                                        </label>
                                        <select
                                            className="form-control col-xl-4 col-md-7"
                                            value={selectedVariant}
                                            onChange={(e) => setSelectedVariant(e.target.value)}
                                        >
                                            <option value="formal">Formal-cálido</option>
                                            <option value="cercano">Cercano-recordatorio</option>
                                            <option value="directo">Directo-práctico</option>
                                        </select>
                                    </div>
                                    <div className="col-sm-12 text-center mt-5 mb-3">
                                        <button
                                            type="submit"
                                            className="btn btn-success"
                                            onClick={handleSubmitPush(sendInvitation)}
                                        >
                                            Enviar invitación
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
});

export default ClientInvitation;
